import LoginForm from "../containers/LoginForm/LoginForm";

const LoginPage = () => {
  return <div><LoginForm /></div>
}

export default LoginPage;
